export type RpcService =
  | 'speak'
  | 'speechClock'
  | 'beginSpeechAudio'
  | 'appendSpeechAudio'
  | 'prepareSpeechAudio'
  | 'scheduleSpeechAudio'
  | 'awaitSpeechAudio'
  | 'stopSpeak'
  | 'startMotion'
  | 'walkForwardSteps'
  | 'walkBackwardSteps'
  | 'walkLeftSteps'
  | 'walkRightSteps'
  | 'walkCurveRightSteps'
  | 'walkCurveLeftSteps'
  | 'playCustomGesture'
  | 'getCurrentAngles'
  | 'measureTOF'
  | 'changeVolume'
  | 'cameraOn'
  | 'cameraOff'
  | 'micOn'
  | 'micOff'
  | 'playSound'
  | 'setLed';

export type RpcErrorPayload = {
  code: string;
  message: string;
  retryable: boolean;
};

export type RpcCall = {
  action: 'call';
  qId: string;
  params: { service: RpcService; data?: unknown };
  flowRunId?: string;
  nodeId?: string;
};

type RpcReplyBase = {
  action: 'reply';
  qId: string;
};

export type RpcReply = RpcReplyBase & (
  | { data: unknown; error?: never }
  | { error: RpcErrorPayload; data?: never }
);

export type RpcCallOptions = {
  flowRunId?: string;
  nodeId?: string;
  signal?: AbortSignal;
  timeoutMs?: number;
};

export class RpcTimeoutError extends Error {
  constructor(readonly robotId: string) {
    super(`RPC timeout: ${robotId}`);
    this.name = 'RpcTimeoutError';
  }
}

export class RpcDisconnectedError extends Error {
  constructor(readonly robotId: string) {
    super(`Robot disconnected: ${robotId}`);
    this.name = 'RpcDisconnectedError';
  }
}

export class RpcRemoteError extends Error {
  constructor(readonly robotId: string, readonly payload: RpcErrorPayload) {
    super(payload.message);
    this.name = 'RpcRemoteError';
  }
}
